@if (loading) {
  <p-skeleton height="3rem"></p-skeleton>
} @else if (hash) {
  <div>
    <h3>Stundenplan-Hash</h3>

    <div class="hash-row">
      <code class="value">{{ hash }}</code>

      <span class="actions">
        <p-button
          size="small"
          type="button"
          pTooltip="Hash kopieren"
          tooltipPosition="bottom"
          icon="pi pi-copy"
          [rounded]="true"
          [text]="true"
          severity="secondary"
          (onClick)="copyToClipboard(hash)"
        ></p-button>

        <app-link-button
          tooltipPosition="bottom"
          tooltip="Öffnet den öffentlichen Stundenplan in einem neuen Tab."
          [href]="link"
          target="_blank"
          iconRight="pi pi-arrow-up-right"
          styleClass="p-button-rounded p-button-text p-button-secondary"
        ></app-link-button>
      </span>
    </div>
  </div>
} @else {
  <div class="schedule-hash muted">
    Noch kein Stundenplan-Hash für diesen Dozenten. Wird automatisch erzeugt,
    sobald ein Eintrag in der Dozentenplanung vorliegt.
  </div>
}
